import BigIcon_module_default from "./BigIcon.module.js";
import classNames from "classnames";
import React from "react";
import { jsx } from "react/jsx-runtime";
//#region src/components/Icon/BigIcon/BigIcon.tsx
function BigIcon({ className, size = "lg", kind = "primary", children }) {
	return /* @__PURE__ */ jsx("div", {
		className: classNames(BigIcon_module_default["big-icon"], className),
		"data-size": size,
		"data-kind": kind,
		children: React.Children.only(children)
	});
}
//#endregion
export { BigIcon };

//# sourceMappingURL=BigIcon.js.map